import React from 'react';
import PropTypes from 'prop-types';
import Overview from '../Overview';
import DocumentCategories from '../DocumentCategories';
import Activities from '../Activities';
import Notes from '../Notes';
import DeniedReason from '../DeniedReason';
import Checks from '../Checks';
import DirectPayments from '../DirectPayments';
import TabContentSkeleton from './TabContentSkeleton';
import { update } from 'lodash';

function DetailTabContent({ tab, claimInformation, claimNotes, dealerInformation, claimContactInformation, claimParts, updateClaim, isLoading, user, userEmail, userName, onSetUserEmail, onSetUserName, fromGlassSearchView, isGlassProcessor, handleSaveNote, handleDeleteClaimNote, handleUpdateClaimNote, claimEvents, documentData }) {
  if (isLoading) {
    return <TabContentSkeleton />
  }

  switch (tab) {
    case 'overview':
      return <Overview
        claimParts={claimParts}
        claimInformation={claimInformation}
        dealerInformation={dealerInformation}
        claimContactInformation={claimContactInformation}
        isGlassProcessor={isGlassProcessor}
        user={user}
        updateClaim={update}
        handleSaveNote={handleSaveNote}
        handleUpdateClaimNote={handleUpdateClaimNote}
        handleDeleteClaimNote={handleDeleteClaimNote}
        claimNotes={claimNotes}
      />
    case 'documents':
      return (
        <DocumentCategories
          claim={claimInformation}
          claimContactInformation={claimContactInformation}
          files={claimInformation.attachments}
          updateClaim={updateClaim}
          documentData={documentData}
          fromGlassSearchView={fromGlassSearchView}
          userEmail={userEmail}
          userName={userName}
          onSetUserEmail={onSetUserEmail}
          onSetUserName={onSetUserName}
          isGlassProcessor={isGlassProcessor}
        />
      );
    case 'activities': return <Activities activities={claimEvents} />

  }
}

DetailTabContent.displayName = 'DetailTabContent';
DetailTabContent.propTypes = {
  tab: PropTypes.string.isRequired,
  claimInformation: PropTypes.shape({
    attachments: PropTypes.array
  }),
  claimNotes: PropTypes.array,
  dealerInformation: PropTypes.object,
  claimContactInformation: PropTypes.object,
  claimParts: PropTypes.array,
  updateClaim: PropTypes.func,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  userEmail: PropTypes.string,
  userName: PropTypes.string,
  onSetUserEmail: PropTypes.func,
  onSetUserName: PropTypes.func,
  fromGlassSearchView: PropTypes.bool,
  isGlassProcessor: PropTypes.bool,
  handleSaveNote: PropTypes.func,
  handleDeleteClaimNote: PropTypes.func,
  handleUpdateClaimNote: PropTypes.func,
  claimEvents: PropTypes.array,
  documentData: PropTypes.shape({
    docCategories: PropTypes.arrayOf(PropTypes.object),
    attachments: PropTypes.arrayOf(PropTypes.object),
  }).isRequired
};

export default DetailTabContent;
